// 客戶管理服務
import { db } from '../cloudsql';

export interface Customer {
  id: string;
  company: string;
  phone?: string;
  address?: string;
  tax_id?: string;
  owner?: string;
  billing_mode?: 'per_project' | 'consolidated';
  created_at: string;
  updated_at: string;
}

export class CustomersService {
  // 取得所有客戶
  async getAll(orderBy?: { field: string; direction: 'asc' | 'desc' }[]): Promise<Customer[]> {
    return db.query<Customer>('customers', {
      orderBy: orderBy || [{ field: 'created_at', direction: 'desc' }]
    });
  }

  // 依 ID 取得客戶
  async getById(id: string): Promise<Customer | null> {
    return db.getById<Customer>('customers', id);
  }

  // 依統一編號查詢
  async getByTaxId(taxId: string): Promise<Customer | null> {
    const results = await db.query<Customer>('customers', {
      where: { tax_id: taxId },
      limit: 1
    });
    return results.length > 0 ? results[0] : null;
  }

  // 搜尋客戶（依公司名稱）
  async search(_term: string): Promise<Customer[]> {
    // 使用 LIKE 查詢需要後端支援，這裡先用簡單的查詢
    // 實際應該在後端實作全文搜尋
    return db.query<Customer>('customers', {
      orderBy: [{ field: 'company', direction: 'asc' }]
    });
  }

  // 建立客戶
  async create(data: Omit<Customer, 'id' | 'created_at' | 'updated_at'>): Promise<Customer> {
    return db.create<Customer>('customers', data);
  }

  // 更新客戶
  async update(id: string, data: Partial<Customer>): Promise<Customer> {
    return db.update<Customer>('customers', id, data);
  }

  // 刪除客戶
  async delete(id: string): Promise<void> {
    return db.delete('customers', id);
  }
}

// 匯出單例
export const customersService = new CustomersService();


